import '.bo{height:100%;}.ssr-plugin'
import '.a0{width:100%;}.ssr-plugin'
import '.dd{min-height:0px;}.ssr-plugin'
import { Image } from '@app/components/core/image/Image'
import { resizeImage } from '@app/util/helpers'
import { Style, styled } from 'inlines'

export type ImagePreviewProps = {
  image: string
  index: number
  wrapperStyle?: Style
  imageStyle?: Style
  onImageClick: (index: number) => void
}

export const ImagePreview = ({
  image,
  index,
  wrapperStyle,
  imageStyle,
  onImageClick,
}: ImagePreviewProps) => {
  // Only apply resizeImage to production URLs, not imported assets
  const imageSrc =
    image?.startsWith('http') && image?.includes('/static/')
      ? image
      : resizeImage(image, 1000)

  return (
    <styled.div className="bo a0 dd"
      style={{ ...wrapperStyle }}
    >
      <Image
        onClick={() => onImageClick(index)}
        src={imageSrc}
        alt={`Initiative image ${index}`}
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          display: 'block',
          ...imageStyle,
        }}
      />
    </styled.div>
  )
}
